import React, { Component } from 'react';
import ListVerificator from './ListVerificator';
import FormAddVerificator from './FormAddVerificator';
import { Button, Menu, Header } from 'semantic-ui-react';

export default class IndexVerificator extends Component {
   constructor(props){
      super(props);
      this.state = {
         action: "add",
         status: false,
         label: "Add user",
         color: 'blue'
      }
      this.onClick = this.onClick.bind(this);
   }

   onClick(){
      const {action} = this.state;
      if(action==="add"){
         this.setState({action:"list",label:"List user", color:'violet'})
      }else{
         this.setState({action:"add",label:"Add user", color:'blue'})
      }
   }

   render() {
      return (
         <div>
            <Menu>
               <Menu.Item>                     
                  <Button onClick={this.onClick} 
                     color={this.state.color}>
                     {this.state.label}
                  </Button>
               </Menu.Item>                     
               <Menu.Item>                     
                  <Header>
                     List data Verifikator
                  </Header>
               </Menu.Item>                     
            </Menu>
            {this.state.action==="add" ? <ListVerificator /> : <FormAddVerificator />}
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_user/_userverificator/IndexVerificator.js